import React, { useEffect } from "react";
import {
    BrowserRouter,
    Switch,
    Route,
    Redirect,
    useHistory,
} from "react-router-dom";
import MainHeader from "../MainHeader/MainHeader";
import Home from "../Home/Home";
import SelectProducts from "../SelectProducts/SelectProducts";
import About from "../About/About";
import Subheader from "../Subheader/Subheader";
import GalleryVideos from "../GalleryVideos/GalleryVideos";
import GalleryRenderings from "../GalleryRenderings/GalleryRenderings";
import GalleryArea from "../GalleryArea/GalleryArea";
import FeaturesAndFinishes from "../FeaturesAndFinishes/FeaturesAndFinishes";
import SitePlan from "../SitePlan/SitePlan";
import Contact from "../Contact/Contact";
import AreaPage from "../AreaPage/AreaPage";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import Tracker from "../Tracker/Tracker";
import SurveyPopup from "../SurveyPopup/SurveyPopup";
import RegisterNow from "../RegisterNow/RegisterNow";
import PnLFloorplans from "../PnLFloorplans/PnLFloorplans";
import PnLFloorplanDetails from "../PnLFloorplanDetails/PnLFloorplanDetails";
import PnLFilterBar from "../PnLFilterBar/PnLFilterBar";
import PnLCompareFloorplans from "../PnLCompareFloorplans/PnLCompareFloorplans";
import ImagePopup from "../ImagePopup/ImagePopup";
import PopupTemplateOne from "../PopupTemplateOne/PopupTemplateOne.js";
import PopupManager from "../PopupManager/PopupManager.js";
import PoppyMultiFlex from "../PoppyMultiFlex/PoppyMultiFlex.js";

function Router() {
    var baseName = "/";

    if (window.location.host === "localhost:8888") {
        //baseName = "/parklake/public";
        baseName = "/park-and-lake-touchscreen-fullsite/public";
    }
    if (window.location.host === "staging.52beta.ca") {
        baseName = "/park-and-lake-touchscreen/public";
    }

    return (
        <BrowserRouter basename={baseName}>
            <PopupManager />
            <Tracker />
            <MainHeader />
            <Switch>
                <Route path="/siteplan" exact>
                    <Redirect to="/site-plan" />
                </Route>
                <Route path="/site-plan">
                    <SitePlan />
                </Route>
                <Route exact path="/floorplans/">
                    <Redirect to="/floorplans/select-products" />
                </Route>
                <Route path="/floorplans/select-products">
                    <SelectProducts />
                </Route>
                <Route path="/floorplans/list">
                    <PnLFilterBar />
                    <PnLFloorplans />
                </Route>
                <Route path="/floorplans/details">
                    <PnLFloorplanDetails />
                </Route>
                <Route path="/floorplans/compare">
                    <PnLCompareFloorplans />
                </Route>
                <Route path="/multi-flex" exact>
                    <Redirect to="/multi-flex/poppy" />
                </Route>
                <Route path="/multi-flex/poppy">
                    <PoppyMultiFlex />
                </Route>
                <Route path="/about">
                    <About></About>
                </Route>
                <Route exact path="/gallery">
                    {/*
                        <Redirect to="/gallery/videos" />
                    */}
                    <Redirect to="/gallery/renderings" />
                </Route>
                <Route path="/gallery/videos">
                    <Subheader></Subheader>
                    <GalleryVideos></GalleryVideos>
                </Route>
                <Route path="/gallery/renderings">
                    <Subheader></Subheader>
                    <GalleryRenderings></GalleryRenderings>
                </Route>
                <Route path="/gallery/amenities">
                    <Subheader></Subheader>
                    <GalleryArea></GalleryArea>
                </Route>
                <Route path="/area">
                    <AreaPage></AreaPage>
                </Route>
                <Route path="/features-and-finishes">
                    <FeaturesAndFinishes></FeaturesAndFinishes>
                </Route>
                <Route path="/contact-us">
                    <Contact></Contact>
                </Route>
                <Route path="/register-now">
                    <Redirect to="/contact-us" />
                    {/*<RegisterNow />*/}
                </Route>
                <Route path="/privacy-policy">
                    <PrivacyPolicy></PrivacyPolicy>
                </Route>
                <Route path="/" exact>
                    <Home></Home>
                </Route>
            </Switch>
        </BrowserRouter>
    );
}

export default Router;
